import { makeActionCreator } from '../../../../utilities'
import { SessionPersistConstants } from './sessionPersist.constants'

export const setIsHydrating = makeActionCreator(SessionPersistConstants.SET_IS_HYDRATING, 'isHydrating')
export const setShowModal = makeActionCreator(SessionPersistConstants.SET_SHOW_MODAL, 'showModal')
export const setPinValues = makeActionCreator(SessionPersistConstants.SET_PIN_VALUES, 'pinValues')
export const setIsResuming = makeActionCreator(SessionPersistConstants.SET_IS_RESUMING, 'isResuming')
export const setErrorMessage = makeActionCreator(SessionPersistConstants.SET_ERROR_MESSAGE, 'errorMessage')
export const setMetadata = makeActionCreator(SessionPersistConstants.SET_METADATA, 'metadata')
export const resetSessionPersistState = makeActionCreator(SessionPersistConstants.RESET_STATE)
